import { ApiResponse } from '@oncolens/oncolens-ui/lib/dto/api/ApiResponse';
import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { Config } from '../configs/cancerConfig';
import { configKeys } from '../configs/config.keys';
import api from '@/utils/httpClient';

export type ConfigTypes =
	| 'behavior'
	| 'ethnicities'
	| 'race'
	| 'setting'
	| 'menopausal'
	| 'recurrence'
	| 'recurrence_areas'
	| 'areas_of_metastasis'
	| 'sex'
	| 'event_history_status'
	| 'panel_type'
	| 'treatment_history_status';

export function getConfig(name: string) {
  const config: any = { containsPHI: false };
  return api
    .get(`/api/configs/${name}`, config)
    .then((response) => (response.data as ApiResponse<Config[]>).data);
}

export default function useConfig(
  configName: ConfigTypes,
  options?: UseQueryOptions<Config[], unknown, Config[], string[]>
): UseQueryResult<Config[]> {
  const allowedConfigs = new Set([
    'behavior',
    'ethnicities',
    'race',
    'setting',
    'menopausal',
    'recurrence',
    'recurrence_areas',
    'areas_of_metastasis',
    'sex',
    'event_history_status',
    'panel_type',
    'treatment_history_status'
  ]);

  if (configName.includes('cancer')) {
    throw new Error('Use the useCancerConfig hook to get cancer config.');
  }

  if (!allowedConfigs.has(configName)) {
    throw new Error(
      `Unsupported config, ${configName}. Supported configs are ${Array.from(allowedConfigs).join(
        ', '
      )}`
    );
  }

  return useQuery(configKeys.detail(configName), async () => getConfig(configName), {
    ...options,
    retry: 1,
    refetchOnWindowFocus: false
  });
}
